// removed by extract-text-webpack-plugin
module.exports = {"title-wrapper":"title-wrapper","titleWrapper":"title-wrapper","email-sent-success":"email-sent-success","emailSentSuccess":"email-sent-success"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account/forgotPasswordFlow/resetPasswordPerformed/style.scss
// module id = 1646
// module chunks = 0